import translate from '@/app/utils/translate';
import { ColumnConfig } from '@/old/utils/helper';
import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import {
  AvatarCell,
  FirstNameCell,
  LastNameCell,
} from '@/app/components/WorkflowsReport/components/KendoCells';

export const useColumnConfigs = (): ColumnConfig[] => {
  return [
    {
      cell: (props: React.PropsWithChildren<GridCellProps>) => (
        <AvatarCell {...props} forceToPeopleModule={true} />
      ),
      field: 'empId',
      show: true,
      title: translate.t('laPicture'),
      width: 88,
    },
    {
      cell: (props: React.PropsWithChildren<GridCellProps>) => (
        <FirstNameCell {...props} forceToPeopleModule={true} />
      ),
      field: 'firstName',
      show: true,
      title: translate.t('laFirstName'),
      width: 150,
    },
    {
      cell: (props: React.PropsWithChildren<GridCellProps>) => (
        <LastNameCell {...props} forceToPeopleModule={true} />
      ),
      field: 'lastName',
      show: true,
      title: translate.t('laLastName'),
      width: 150,
    },
    {
      field: 'employeeNumber',
      show: true,
      title: translate.t('laEmpNumber'),
      width: 150,
    },
    {
      field: 'unit',
      show: true,
      title: translate.t('laUnit'),
      width: 150,
    },
    {
      field: 'position',
      title: translate.t('laPosition'),
      width: 150,
      show: true,
    },
    {
      field: 'worklistName',
      show: true,
      title: translate.t('laWorklistName'),
      width: 150,
    },
    {
      field: 'worklistStatus',
      show: true,
      title: translate.t('laStatus'),
      width: 150,
    },
    {
      field: 'startDate',
      show: true,
      title: translate.t('laStartDate'),
      width: 150,
      format: '{0:yyyy-MM-dd}',
    },
    {
      field: 'dueDate',
      show: true,
      title: translate.t('laDueDate'),
      width: 150,
      format: '{0:yyyy-MM-dd}',
    },
  ];
};
